/* Slide the footer menus open and shut.
 *
 * <details> has no transitionable state of its own: the browser hides the
 * panel outright when the element is closed, so there is nothing for CSS to
 * animate between. The panel is therefore driven by hand -- `open` is set
 * before the opening animation and removed only after the closing one, so the
 * content stays in the box for the whole transition.
 *
 * Above 750px the summary is pointer-events: none and the panel is forced
 * visible by CSS, so none of this runs.
 */
(function () {
  var DURATION = 260;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function settle(details, panel) {
    delete details.dataset.state;
    panel.style.height = '';
    panel.style.overflow = '';
    panel.style.opacity = '';
  }

  function slide(details, panel, opening) {
    var full = panel.scrollHeight;
    details.dataset.state = opening ? 'opening' : 'closing';
    panel.style.overflow = 'hidden';

    var animation = panel.animate(
      [
        { height: (opening ? 0 : full) + 'px', opacity: opening ? 0 : 1 },
        { height: (opening ? full : 0) + 'px', opacity: opening ? 1 : 0 },
      ],
      { duration: DURATION, easing: EASING }
    );

    animation.onfinish = function () {
      if (!opening) details.open = false;
      settle(details, panel);
    };

    // A cancelled animation must not leave the panel clamped to zero height
    animation.oncancel = function () {
      settle(details, panel);
    };
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var summary = event.target.closest('.footer-block__collapsible-summary');
    if (!summary) return;

    var details = summary.parentElement;
    var panel = details && details.querySelector('.footer-block__details-content');
    if (!panel || reducedMotion()) return;

    // Ignore re-clicks while a slide is in flight rather than queueing them
    if (details.dataset.state) {
      event.preventDefault();
      return;
    }

    if (details.open) {
      // Hold the panel open for the duration; `open` comes off at the end
      event.preventDefault();
      slide(details, panel, false);
    } else {
      // Clamp before the browser paints the opened panel, or it flashes at
      // full height for one frame before the animation takes over.
      panel.style.height = '0px';
      panel.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        slide(details, panel, true);
      });
    }
  });
})();
